import React, { Component } from 'react';
import './style.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import decodeHTMLEntities from '../../../../helpers/decodeHTMLEntities';

class Question extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {item, quiz} = this.props;
    let answers = {};

    if(item.student_answer && item.student_answer.answer_order){
      
      item.student_answer.answer_order.split(',').forEach(key => {
        answers[key] = item.answers[key];
      });
    } else {
      answers = item.answers;
    }
    const arrayChar = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

    const value = item.student_answer && item.student_answer.answer || '';
    const {formatMessage} = this.context;
    return (
      <div className="Question">
        <div className="question-content" dangerouslySetInnerHTML={{__html: item.question}}></div>
        <div className="question-answer">
          {answers ? Object.keys(answers).map((key, index) => (
            <div 
              key={'answer-' + item.id + '-' + index} 
              className={classNames("custom-control custom-radio question-answer-item", {
                'answer-true': item.student_answer && quiz.answers_after_done_type && key == item.correct_answer,
                'answer-false': item.student_answer && key != item.correct_answer && value == key,
              })}
            >
  <label className="custom-control-label" htmlFor={'answer-' + item.id + '-' + index}><div className="char">{arrayChar[index]}</div><div>{decodeHTMLEntities(item.answers[key])}</div></label>
            </div>
          )) : null}
        </div>
        {!item.is_answer && <div className="alert alert-danger" role="alert">
          {formatMessage('studentIsNotAnswer')}
        </div>}
        <hr/>
      </div>
    );
  }
}

export default Question;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StudentAnswerQuiz/components/Question/index.jsx